import DashboardView from "../DashboardView.vue";
import DashboardPage from "../Pages/DashboardPage.vue";

const routes = [
  {
    path: '/',
    component: DashboardView,
    children: [
      {
        path: '',
        name: 'celulares-dashboard',
        component: DashboardPage,
        roles: ['user'],
      },
    ]
  }
]

export default routes
